export function formatDistanceMeters(distanceMeters: number): string {
    if (distanceMeters >= 1000) {
        if (distanceMeters % 1000 !== 0) {
            if (distanceMeters % 100 !== 0) {
                return `${(distanceMeters / 1000).toFixed(2)}k`;
            }
            return `${(distanceMeters / 1000).toFixed(1)}k`;
        }
        return `${distanceMeters / 1000}k`;
    }
    return `${distanceMeters}m`;
}
